/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import { Button } from '@mui/material';

export const MainBtn = withStyles((theme: Theme) =>
    createStyles({
        root: {
            width: 'inherit',
            background: theme.palette.primary.main,
            color: 'white',
            '&:hover': {
                background: theme.palette.primary.main,
            },
        },
    }),
)(Button);

export const MainBtnLight = withStyles((theme: Theme) =>
    createStyles({
        root: {
            width: 'inherit',
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            '&:disabled': {
                color: theme.palette.disabledText.main,
                borderColor: theme.palette.disabledText.main,
            },
        },
    }),
)(Button);

export const GroupBtnPrimary = withStyles((theme: Theme) =>
    createStyles({
        root: {
            borderColor: theme.palette.primary.main,
            textWrap: 'nowrap',
            whiteSpace: 'nowrap',
            '&:hover': {
                background: theme.palette.primary.main,
                color: 'white',
            },
        },
    }),
)(Button);

export const RedMainBtn = withStyles((theme: Theme) =>
    createStyles({
        root: {
            background: theme.palette.error.main,
            color: 'white',
            '&:hover': {
                background: theme.palette.error.main,
            },
            '&:disabled': {
                background: theme.palette.coral.light,
            },
        },
    }),
)(Button);
